
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AirportDetailsComponent } from './airport-details.component';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";


@NgModule({
    imports: [
        CommonModule,
        FontAwesomeModule,
    ],
    exports: [
        AirportDetailsComponent,
    ],
    declarations: [
        AirportDetailsComponent,
    ],
})
export class AirportDetailsModule { }

